import { Modal, Button } from 'react-bootstrap';
import { handleError } from '../../../shared/ErrorCatching';
import { assign } from '../../../shared/Assign';
import { connect } from 'react-redux';
import { Translate } from '../../../shared/LanguageService';
import * as Actions from './Actions';
import * as React from 'react';
import SpecialAuthorizationsList from './SpecialAuthorizationsList';
import notify from '../../../shared/feedback/notifications';
import { ISpecialAuthorization, ISpecialAuthorizationsGroup } from './Types';

export class SpecialAuthorizationsModal extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            groups: []
        };

        this.closeModal = this.closeModal.bind(this);
        this.toggleListGroupExpansion = this.toggleListGroupExpansion.bind(this);
        this.toggleItemIsAssigned = this.toggleItemIsAssigned.bind(this);
        this.save = this.save.bind(this);
    }

    componentDidMount(): void {
        this.props.actions
            .edit(this.props.userId)
            .then(() =>
                this.setState({
                    groups: this.props.groups.map((x: ISpecialAuthorizationsGroup) => assign({}, x))
                })
            )
            .catch((error: any) => handleError(error));
    }

    closeModal(): void {
        this.props.actions.clear().then(this.props.closeModal()).catch(this.props.closeModal());
    }

    toggleListGroupExpansion(value: number): void {
        let group = assign(
            {},
            this.state.groups.filter((x: ISpecialAuthorizationsGroup) => x.value === value)[0]
        );
        group.isExpanded = !group.isExpanded;

        let groups = [
            ...this.state.groups.filter((x: ISpecialAuthorizationsGroup) => x.value !== value),
            group
        ];

        this.setState({ groups: groups });
    }

    toggleItemIsAssigned(item: ISpecialAuthorization): void {
        let newGroup: ISpecialAuthorizationsGroup = assign(
            {},
            this.state.groups.filter((x: ISpecialAuthorizationsGroup) => x.value === item.group)[0]
        );
        let newItem: ISpecialAuthorization = assign({}, item);

        newItem.isAssigned = !newItem.isAssigned;
        newGroup.items = [
            ...newGroup.items.filter((x: ISpecialAuthorization) => x.value !== item.value),
            newItem
        ];

        let groups = [
            ...this.state.groups.filter(
                (x: ISpecialAuthorizationsGroup) => x.value !== newGroup.value
            ),
            newGroup
        ];

        this.setState({ groups: groups });
    }

    save(): void {
        let creates: number[] = [];
        let deletes: number[] = [];

        for (let group of this.state.groups) {
            for (let item of group.items) {
                let refGroup = this.props.groups.filter(
                    (x: ISpecialAuthorizationsGroup) => x.value === group.value
                )[0];
                let refItem = refGroup.items.filter(
                    (x: ISpecialAuthorization) => x.value === item.value
                )[0];

                if (item.isAssigned && !refItem.isAssigned) {
                    creates.push(item.value);
                } else if (item.isAssigned === false && refItem.isAssigned) {
                    deletes.push(item.value);
                }
            }
        }

        if (creates.length > 0 || deletes.length > 0) {
            this.props.actions
                .update(this.props.userId, creates, deletes)
                .then(() => {
                    notify.success(
                        Translate('special-authorizations/notification/update-succeeded')
                    );
                    this.closeModal();
                })
                .catch((error: any) => handleError(error));
        } else {
            this.closeModal();
        }
    }

    render(): any {
        return (
            <div>
                <Modal show={this.props.shouldShowModal} onHide={this.closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>{Translate('special-authorizations/modal/title')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <SpecialAuthorizationsList
                            groups={this.state.groups}
                            toggleExpansion={this.toggleListGroupExpansion}
                            toggleItemIsAssigned={this.toggleItemIsAssigned}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.closeModal}>
                            {Translate('special-authorizations/modal/button-label/close')}
                        </Button>
                        <Button bsStyle="primary" onClick={this.save}>
                            {Translate('special-authorizations/modal/button-label/save')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any): any {
    return {
        groups: state.specialAuthorizations.edit.groups
    };
}

function mapDispatchToProps(dispatch: any): any {
    return {
        actions: {
            edit: (userId: number) => dispatch(Actions.edit(userId)),
            clear: () => dispatch(Actions.clear()),
            update: (userId: number, creates: number[], deletes: number[]) =>
                dispatch(Actions.update(userId, creates, deletes))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SpecialAuthorizationsModal);
